import DefaultRouter from './DefaultRouter';
import DetailRouter from './DetailRouter';

const DefaultView = () => import('../views/DefaultView');
const NewsletterView = () => import('../views/NewsletterView');
const InterestView = () => import('../views/InterestView');

export default [
    {
        path:      'customers',
        component: DefaultRouter,
        children:  [
            {
                path:      '',
                name:      'project-customer-default',
                component: DefaultView,
            }, {
                path:      'c',
                component: DetailRouter,
                children:  [
                    {
                        path:      'interest',
                        name:      'project-customer-interest',
                        component: InterestView,
                    }, {
                        path:      'newsletter',
                        name:      'project-customer-newsletter',
                        component: NewsletterView,
                    }
                ]
            }
        ]
    }
]
